import * as angular from "angular";
import {AddressesRequests} from "./addresses-requests.service";
import {AddressResolverEntryEntity} from "../models/address-resolver-entry.model";
import {IPromise, IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";

export class AddressesService {

  constructor(private addressesRequests: AddressesRequests, private $q: IQService,
              private commonsAlertsService: CommonsAlertsService, private $log, private bringozLoaderService: BringozLoaderService) {
  }

  //TODO might be redundant
  getAddressLocation(latitude: number, longitude: number) {
    return {
      latitude: latitude,
      lat: latitude,
      longitude: longitude,
      lng: longitude
    };
  }

  updateAddress(address, futureStreetResolution, futureCityResolution,
                updateServices?: boolean, updateAccounts?: boolean): IPromise<AddressResolverEntryEntity> {
    const deferred = this.$q.defer<AddressResolverEntryEntity>();

    this.bringozLoaderService.on();
    this.addressesRequests.updateAddress(address, futureStreetResolution, futureCityResolution,
      updateServices, updateAccounts)
        .then((response: AddressResolverEntryEntity) => {
          this.commonsAlertsService.updateAddressSuccess(address.originalAddress);
          deferred.resolve(response);
        })
        .catch((error) => {
          this.commonsAlertsService.updateAddressError();
          this.$log.error('Failed to update address @addressesResolverView@saveAddress', error);
          deferred.reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })

    return deferred.promise;
  }

  getOrdersAndDeliveriesUsingAddress(addressId): IPromise<any> {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.addressesRequests.getOrdersAndDeliveriesUsingAddress(addressId)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;

  }

  getAddressByAddressId(addressId: string): IPromise<AddressResolverEntryEntity> {
    const deferred = this.$q.defer<AddressResolverEntryEntity>();

    this.bringozLoaderService.on();
    this.addressesRequests.getAddress(addressId)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  getValidatedAddress(addressObj): IPromise<any> {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.addressesRequests.validateAddress(addressObj)
        .then((response) => {
          deferred.resolve(response);
        })
        .catch((error) => {
          deferred.reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.addresses')
  .service('addressesService', AddressesService);
